module.exports = __webpack_public_path__ + "static/img/image_solutions_system_01.6c07f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_system_01.png
// module id = dJN7
// module chunks = 10